import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  color: ${({ theme }) => theme.mainTextColor};
  cursor: pointer;
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px !important;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        align-items: center;
        justify-content: center;
        min-height: 40px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          text-align: center;
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
    }
  }
`;

const KiralikAracContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const storageUserId = JSON.parse(storage.getItem("userId"));
  const dispatch = useDispatch();

  const showOptions = () => {
    if(data?.userId === storageUserId ){
      dispatch(setSelectRentalCar(data));
      dispatch(showModal("rentalCarOptions"));
    }
  }
  
  return (
    <Container onClick={showOptions}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data?.id}</div>
            <div className="col">{moment(data?.createdAt).format('L')}</div>
            <div className="col">{data?.vehicleType}</div>
            <div className="col">{data?.bodyType}</div>
            <div className="col">{data?.truckVehicleWorkCities.$values.map((item, i) => {
              return `${item.city}${i+1 !== data?.truckVehicleWorkCities.$values.length ? ", " : ""}`
            })}</div>
            <div className="col">{data?.workRoute}</div>
            <div className="col">{data?.fuelPercentage}</div>
            <div className="col">{data?.rentalPrice}</div>
            <div className="col">{data?.contactNumber}</div>
            
            {/* {
              data?.userId === storageUserId && 
              <div onClick={()=> {dispatch(setSelectRentalCar(data)); dispatch(showModal("rentalCarOptions")) }} className="more"><MdOutlineMoreHoriz/></div>
            } */}
            
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KiralikAracContainer;
